import { Applog, ApplogEncNoCid } from './applog/datom-types.ts'

export const isTruthy = (l: Applog | ApplogEncNoCid): boolean => !!l
export const keepTruthy = (arr: readonly any[]): any[] => arr.filter(isTruthy)
